// ConfirmDialog.js
import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Checkbox,
  Button
} from '@mui/material';

const ConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  title = "Are you sure?",
  cancelText = "Cancel",
  confirmText = "Confirm",
  confirmColor = "#f05f40",
  cancelColor = "#333",
  showIntegratedCheckBoxes = false,
  children,
}) => {
  const [checked, setChecked] = useState({
    mainline: false,
    sidebar: false,
  });

  const [mcpStatus, setMcpStatus] = useState(false);

  useEffect(() => {
    if (!open) {
      // Reset checkbox state when dialog is closed
      setChecked({ mainline: false, sidebar: false });
      setMcpStatus(false);
    }
  }, [open]);

  const handleCheckboxChange = (event) => {
    const { name, checked: value } = event.target;
    setChecked((prev) => ({ ...prev, [name]: value }));
  };

  const handleMcpChange = (event) => {
    setMcpStatus(event.target.checked);
  };

  const handleConfirm = () => {
    if (showIntegratedCheckBoxes) {
      onConfirm(checked, mcpStatus);
    } else {
      onConfirm();
    }
  };

  return (
    <Dialog onClose={onClose} open={open}>
      <DialogTitle>{title}</DialogTitle>

      {(showIntegratedCheckBoxes || children) && (
        <DialogContent>
      {showIntegratedCheckBoxes && (
        <>
          <FormControlLabel
            control={
              <Checkbox
                checked={checked.mainline}
                onChange={handleCheckboxChange}
                name="mainline"
              />
            }
            label="Mainline"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={checked.sidebar}
                onChange={handleCheckboxChange}
                name="sidebar"
              />
            }
            label="Sidebar"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={mcpStatus}
                onChange={handleMcpChange}
                name="mcpStatus"
              />
            }
            label="MCP Enabled"
          />
        </>
      )}
      {children}
        </DialogContent>
      )}

      <DialogActions>
        <Button onClick={onClose} style={{ color: cancelColor }}>
          {cancelText}
        </Button>
        <Button onClick={handleConfirm} autoFocus style={{ color: confirmColor }}>
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
